/**
 * @deprecated since v5.0.0. Use terra-form instead.
 */
export enum TerraControlTypeEnum {
    CHECK_BOX = 'checkBox',
    CONDITIONAL_CONTAINER = 'conditionalContainer',
    DATE_PICKER = 'datePicker',
    HORIZONTAL_CONTAINER = 'horizontalContainer',
    INPUT_FILE = 'inputFile',
    INPUT_TEXT = 'inputText',
    INPUT_TEXT_AREA = 'inputTextArea',
    INPUT_NUMBER = 'inputNumber',
    INPUT_DOUBLE = 'inputDouble',
    SELECT_BOX = 'selectBox',
    VERTICAL_CONTAINER = 'verticalContainer',
    CATEGORY_PICKER = 'categoryPicker',
    COLOR_PICKER = 'colorPicker',
    MULTI_CHECK_BOX = 'multiCheckBox',
    NOTE_EDITOR = 'noteEditor',
    CODE_EDITOR = 'codeEditor'
}
